import { useMutation } from "@tanstack/react-query";

import { LeadForm } from "../LeadForm/LeadForm";
import { requests } from "../../../../services/http-common";
import { useNavigate } from "react-router-dom";
import { useToast } from "../../../../Providers/ToastProvider";
import { DCSQueryClient } from "../../../../queryClient";
import { SectionHeader } from "../../../../components/SectionHeader/SectionHeader";

export const LeadCreate = () => {
  const navigate = useNavigate();
  const { show } = useToast();

  const createLead = useMutation({
    mutationFn: (newLead: any) => {
      return requests.post("/lead", { ...newLead, sendStatus: false });
    },
    onSuccess: () => {
      show({ detail: "Lead was created successfully !" });
      navigate("/sales/leads");
      DCSQueryClient.invalidateQueries({ queryKey: ["leads-list"] });
    },
    onError: (error: any) => {
      show({
        severity: "error",
        detail: error.response?.data?.error?.message || "Something went wrong ",
      });
    },
  });

  return (
    <>
      <SectionHeader title="Create New Lead" />
      <LeadForm onSubmit={createLead.mutate} isPending={createLead.isLoading} />
    </>
  );
};
